module.exports = __webpack_public_path__ + "img/chatBox_bg.babaeb2.png";